import React from 'react'
import styles from '@/src/components/scss/Schedule.module.scss'
import { Box, useMediaQuery } from '@mui/material'
import { Typography, Button } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import Call40 from '@evocolabs/icons/lib/Call40'
import HandLock40 from '@evocolabs/icons/lib/HandLock40'
import Graph40 from '@evocolabs/icons/lib/Graph40'
import AudiologistShield40 from '@evocolabs/icons/lib/AudiologistShield40'
import { useSchedule } from '@/components/Schedule/ScheduleRoot'

const features = [
  {
    icon: <Call40 />,
    title: '15-minute phone call',
    content:
      'To quickly pinpoint your hearing loss and get advice from professionals.'
  },
  {
    icon: <AudiologistShield40 />,
    title: 'Licensed hearing specialists',
    content:
      'Talk to trusted audiologist and have your hearing solution tailored for yourself.'
  },
  {
    icon: <HandLock40 />,
    title: 'Convenient and private',
    content:
      'Book a slot at your convenience and enjoy 1:1 service at the comfort of your couch.'
  },
  {
    icon: <Graph40 />,
    title: 'Detailed interpretation of results',
    content:
      'Get your results interpreted by audiologist and understand your hearing better.'
  }
]
const PCColor = [
  theme.palette.white.cold,
  theme.palette.primary[100],
  theme.palette.primary[100],
  theme.palette.white.cold
]
const NonPCColor = [
  theme.palette.white.cold,
  theme.palette.primary[100],
  theme.palette.white.cold,
  theme.palette.primary[100]
]

const Introduction = () => {
  const usePC = useMediaQuery(theme.breakpoints.up('md'))
  const { viewId, setViewId, history } = useSchedule()

  function handleClick() {
    history.push(viewId)
    setViewId(viewId + 1)
  }

  return (
    <Box className={styles.viewRoot}>
      <Typography variant="h3">Schedule Your Phone Consultation</Typography>
      <Typography variant="body1" sx={{ mt: '8px' }}>
        If you are an Orka user, it's suggested to schedule a video meeting with
        our audiologist via our email invitation.
      </Typography>
      <Box className={styles.introFeatures}>
        {features.map((item, idx) => (
          <Box
            key={item.title}
            className={styles.introFeatureBox}
            sx={{ bgcolor: usePC ? PCColor[idx] : NonPCColor[idx] }}
          >
            {item.icon}
            <Box sx={{ ml: '8px' }}>
              <Typography variant="subh1" sx={{ fontWeight: 600 }}>
                {item.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mt: '4px',
                  color: theme.palette.grey[700]
                }}
              >
                {item.content}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
      <Button size="large" handleClick={handleClick}>
        continue
      </Button>
    </Box>
  )
}

export default Introduction
